import { instance } from "hooks/useRequest/helper";
import { USER_URL } from "api/routes";
import tokenService from "services/token.service";
import { IApiRequestDataWithId, IServerResponse } from "rules/interface/api/response";
import IUpdateUser from "rules/interface/api/user/update-user.interface";


export const updateUser = async ({ id, data }: IApiRequestDataWithId<IUpdateUser>): Promise<IServerResponse<{}>> => {
    return await instance.put(USER_URL + "/" + id, data, {
        headers: {
            authorization: `Token ${tokenService.getLocalAccessToken()}`
        }
    })
        .then(res => res.data)
};